module.exports = __webpack_public_path__ + "static/media/image.9cd64720.jpg";